module.exports = __webpack_public_path__ + "img/gift.3f43ce2.svg";